import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { environment } from '../../../environments/environment';
import { ClaimsService } from '../../services/claims.service';
import { StateService } from '../../services/state.service';
import { MatCardModule } from '@angular/material/card';
import { MsalService } from '@azure/msal-angular';
import { Claim } from '../../models/claim.model';
import { Component } from '@angular/core';

@Component({
    selector: 'app-logout',
    standalone: true,
    imports: [MatCardModule, MatProgressSpinnerModule],
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css']
})

export class LogoutComponent {
    _claim?: Claim;
    _isLoggedIn: boolean = true;

    constructor(
        private authService: MsalService,
        private stateService: StateService,
        private claimsService: ClaimsService
    ) { }

    ngOnInit(): void {
        this._claim = this.stateService.claim;
        this._isLoggedIn = this.stateService.$loginDisplay.value;

        this.logout();
    }

    logout(): void {
        if (!this._claim || !this._claim.claimReference) {
            console.error('Error: Claim is undefined or missing claim reference.');
            this.updateLogoutState(false); 
            this.performFallbackLogout();
            return;
        }

        this.claimsService.loadGuid(this._claim.claimReference).subscribe({
            next: (response) => {
                const guid = response.urlGuid;

                if (!guid) {
                    console.error('Error: Received invalid GUID.');
                    this.updateLogoutState(false);
                    this.performFallbackLogout();
                    return;
                }

                const redirectUrl = `/${guid}/login`;
                this.updateLogoutState(true);
                this.authService.logoutRedirect({ postLogoutRedirectUri: redirectUrl });
            },
            error: (error) => {
                console.error('Error fetching GUID:', error);
                this.updateLogoutState(false);
                this.performFallbackLogout();
            }
        });
    }

    private performFallbackLogout(): void {
        this.updateLogoutState(false);
        this.authService.logoutRedirect({ postLogoutRedirectUri: `/${environment.defaultGuid}/login` });
    }

    private updateLogoutState(isValidLogout: boolean): void {
        if(isValidLogout){
            this.stateService.$loginDisplay.next(true);
            this.stateService.isSigningUp = true;
            localStorage.setItem('signingUp', JSON.stringify(true));
            this._isLoggedIn = false;
        }else{
            this.stateService.$loginDisplay.next(false);
            localStorage.setItem('signingUp', JSON.stringify(false));
            this.stateService.isSigningUp = false;
            this._isLoggedIn = false;
        }
    }
}
